import { motion } from "framer-motion";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";

export default function CGVPage() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-[#F5F5F0]"
    >
      <Navbar />
      <SEO
        path="/cgv"
        title="Conditions Générales de Vente — PROBWA La Réunion"
        description="CGV de PROBWA — Eco Bois Concept. Conditions de vente, livraison, retours et garanties pour nos produits en bambou REBO à La Réunion."
      />
      <main className="pt-24">
        {/* Hero */}
        <section className="py-12 md:py-16 bg-[#2D2D2D]">
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl font-bold text-[#E8E8E8]"
              style={{ fontFamily: "'DM Serif Display', serif" }}
              data-testid="cgv-title"
            >
              Conditions Générales <span className="text-[#8BC34A]">de Vente</span>
            </motion.h1>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-24">
          <div className="max-w-4xl mx-auto px-6 md:px-12">
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl space-y-8">
              
              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 1 - OBJET ET CHAMP D'APPLICATION
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les 
                  ventes de produits en bambou effectuées par la société PROBWA, société au 
                  capital de 900 euros, inscrite au R.C.S. de Saint-Denis-de-La-Réunion sous 
                  le numéro 982 037 558, dont le siège social est situé au 7 RUE ELIE EUDOR 
                  BUREAU N3, 97460 SAINT-PAUL, La Réunion (ci-après « le Vendeur »).<br /><br />
                  Toute commande passée auprès du Vendeur implique l'acceptation sans réserve 
                  des présentes CGV par l'acheteur (ci-après « le Client »). Ces CGV prévalent 
                  sur toutes autres conditions générales ou particulières non expressément 
                  agréées par le Vendeur.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 2 - PRODUITS
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le Vendeur propose les produits suivants :<br /><br />
                  • Lames de terrasse en bambou tressé carbonisé (Tropic Miel, Tropic Teck, Tropic Intense)<br />
                  • Bardage en bambou tressé carbonisé<br />
                  • Tasseaux en bambou<br />
                  • Plancher intérieur en bambou tressé carbonisé<br />
                  • Panneaux de revêtement mural en bambou décoratif préhuilé<br /><br />
                  Les caractéristiques essentielles des produits sont présentées sur le site 
                  internet www.probwa.re. Les photographies et illustrations présentées sur le 
                  site ne sont pas contractuelles et ne sauraient engager la responsabilité du 
                  Vendeur. Le bambou étant un produit naturel, de légères variations de teinte 
                  ou de texture peuvent exister entre les produits.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 3 - DEVIS ET COMMANDES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>3.1 Demande de devis</strong><br />
                  Toute commande est précédée d'un devis personnalisé établi gratuitement par 
                  le Vendeur. Le devis détaille les produits, quantités, prix unitaires et total, 
                  ainsi que les conditions de livraison et de paiement.<br /><br />
                  <strong>3.2 Validité du devis</strong><br />
                  Le devis est valable pendant une durée de 30 jours à compter de sa date d'émission. 
                  Passé ce délai, le Vendeur se réserve le droit de modifier les prix.<br /><br />
                  <strong>3.3 Confirmation de commande</strong><br />
                  La commande devient définitive après :<br />
                  • Acceptation écrite du devis par le Client (signature du devis)<br />
                  • Versement de l'acompte prévu à l'article 5<br /><br />
                  Toute modification de la commande par le Client après confirmation devra faire 
                  l'objet d'un nouveau devis.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 4 - PRIX
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Les prix sont indiqués en euros et s'entendent TTC (toutes taxes comprises).<br /><br />
                  Les prix comprennent uniquement les produits tels que décrits dans le devis. 
                  La livraison et la pose ne sont pas incluses dans les prix des produits, sauf 
                  mention contraire sur le devis.<br /><br />
                  Le Vendeur se réserve le droit de modifier ses prix à tout moment. Toutefois, 
                  les produits seront facturés sur la base des tarifs en vigueur au moment de 
                  la validation du devis.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 5 - MODALITÉS DE PAIEMENT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>5.1 Acompte</strong><br />
                  Un acompte de 30% du montant total TTC est exigé à la commande. Cet acompte 
                  n'est pas remboursable en cas d'annulation par le Client, sauf accord express 
                  du Vendeur.<br /><br />
                  <strong>5.2 Solde</strong><br />
                  Le solde (70% restant) est payable :<br />
                  • À la livraison des produits, ou<br />
                  • Avant le début des travaux de pose si le Vendeur assure l'installation<br /><br />
                  <strong>5.3 Moyens de paiement acceptés</strong><br />
                  • Virement bancaire<br />
                  • Chèque bancaire<br />
                  • Espèces (dans la limite légale de 1 000 €)<br /><br />
                  <strong>5.4 Retard de paiement</strong><br />
                  En cas de retard de paiement, des pénalités de retard seront appliquées au 
                  taux de trois fois le taux d'intérêt légal, conformément à l'article L441-10 
                  du Code de commerce. Une indemnité forfaitaire de 40 € pour frais de recouvrement 
                  sera également due.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 6 - LIVRAISON
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>6.1 Délais de livraison</strong><br />
                  Les délais de livraison sont indiqués sur le devis et varient selon les 
                  produits et leur disponibilité. Ces délais sont donnés à titre indicatif 
                  et ne constituent pas un engagement ferme du Vendeur.<br /><br />
                  <strong>6.2 Lieu de livraison</strong><br />
                  La livraison s'effectue à l'adresse indiquée par le Client lors de la commande. 
                  Le Client doit s'assurer de l'accessibilité du lieu de livraison.<br /><br />
                  <strong>6.3 Réception des produits</strong><br />
                  Le Client doit vérifier l'état apparent des produits à la réception. 
                  Toute anomalie (produit manquant, endommagé, non conforme) doit être signalée 
                  sur le bon de livraison et confirmée par écrit au Vendeur dans les 48 heures 
                  suivant la livraison.<br /><br />
                  <strong>6.4 Transfert des risques</strong><br />
                  Le transfert des risques s'opère dès la livraison des produits au Client.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 7 - RÉSERVE DE PROPRIÉTÉ
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Le Vendeur conserve la propriété des produits vendus jusqu'au paiement 
                  intégral du prix par le Client, en principal et accessoires. Le défaut de 
                  paiement peut entraîner la revendication des produits.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 8 - GARANTIE
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>8.1 Garantie légale de conformité</strong><br />
                  Conformément aux articles L217-4 et suivants du Code de la consommation, 
                  le Vendeur est tenu de livrer un bien conforme au contrat et répond des 
                  défauts de conformité existant lors de la délivrance.<br /><br />
                  <strong>8.2 Garantie des vices cachés</strong><br />
                  Conformément aux articles 1641 et suivants du Code civil, le Vendeur est 
                  tenu de la garantie à raison des défauts cachés de la chose vendue.<br /><br />
                  <strong>8.3 Garantie produits bambou</strong><br />
                  Nos produits en bambou tressé carbonisé bénéficient d'une durabilité certifiée :<br />
                  • Classe de durabilité 1 (EN350)<br />
                  • Classe d'utilisation 4 (EN335)<br /><br />
                  <strong>8.4 Exclusions de garantie</strong><br />
                  La garantie ne couvre pas :<br />
                  • L'usure normale des produits<br />
                  • Les dommages causés par une utilisation non conforme aux préconisations<br />
                  • Les dommages causés par un entretien inadéquat<br />
                  • Les modifications apportées aux produits par le Client ou un tiers<br />
                  • Les variations naturelles de teinte du bambou
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 9 - DROIT DE RÉTRACTATION
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>9.1 Principe</strong><br />
                  Conformément à l'article L221-18 du Code de la consommation, pour les 
                  contrats conclus à distance, le Client consommateur dispose d'un délai 
                  de 14 jours à compter de la réception des produits pour exercer son droit 
                  de rétractation, sans avoir à motiver sa décision.<br /><br />
                  <strong>9.2 Exceptions</strong><br />
                  Conformément à l'article L221-28 du Code de la consommation, le droit de 
                  rétractation ne s'applique pas aux :<br />
                  • Produits fabriqués sur mesure ou personnalisés selon les spécifications du Client<br />
                  • Produits qui ont été descellés après la livraison et qui ne peuvent être 
                  renvoyés pour des raisons d'hygiène ou de protection de la santé<br /><br />
                  <strong>9.3 Exercice du droit de rétractation</strong><br />
                  Pour exercer ce droit, le Client doit notifier sa décision par écrit au 
                  Vendeur (email ou courrier) avant l'expiration du délai. Les produits 
                  doivent être retournés dans leur état d'origine, dans leur emballage d'origine, 
                  accompagnés de la facture. Les frais de retour sont à la charge du Client.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 10 - RESPONSABILITÉ
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  <strong>10.1 Responsabilité du Vendeur</strong><br />
                  La responsabilité du Vendeur est limitée au montant de la commande. 
                  Le Vendeur ne pourra être tenu responsable des dommages indirects, 
                  pertes d'exploitation ou préjudices immatériels.<br /><br />
                  <strong>10.2 Force majeure</strong><br />
                  Le Vendeur ne saurait être tenu responsable de l'inexécution de ses 
                  obligations en cas de force majeure telle que définie par l'article 1218 
                  du Code civil (événement imprévisible, irrésistible et extérieur aux parties).
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 11 - DONNÉES PERSONNELLES
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Les données personnelles collectées dans le cadre de la relation commerciale 
                  sont traitées conformément à notre Politique de Confidentialité, disponible 
                  sur le site www.probwa.re, et dans le respect du Règlement Général sur la 
                  Protection des Données (RGPD).
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 12 - LITIGE – MÉDIATION DE LA CONSOMMATION
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  En cas de litige entre le Client et l'entreprise, ceux-ci s'efforceront de 
                  le résoudre à l'amiable (le Client adressera une réclamation écrite auprès 
                  du professionnel ou, le cas échéant, auprès du Service Relations Clientèle 
                  du professionnel).<br /><br />
                  A défaut d'accord amiable ou en l'absence de réponse du professionnel dans 
                  un délai raisonnable d'un (1) mois, le Client consommateur au sens de 
                  l'article L.612-2 du code de la consommation a la possibilité de saisir 
                  gratuitement, si un désaccord subsiste, le médiateur compétent inscrit sur 
                  la liste des médiateurs établie par la Commission d'évaluation et de contrôle 
                  de la médiation de la consommation en application de l'article L.615-1 du 
                  code de la consommation, à savoir :<br /><br />
                  <strong>La Société Médiation Professionnelle</strong><br />
                  <a href="http://www.mediateur-consommation-smp.fr" target="_blank" rel="noopener noreferrer" className="text-[#8BC34A] underline">
                    www.mediateur-consommation-smp.fr
                  </a><br />
                  Alteritae 5 rue Salvaing 12000 Rodez<br /><br />
                  Le Client peut également recourir à la plateforme européenne de règlement 
                  en ligne des litiges (RLL) accessible à l'adresse suivante :{" "}
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#8BC34A] underline">
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 13 - DROIT APPLICABLE ET JURIDICTION
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Les présentes CGV sont soumises au droit français.<br /><br />
                  En cas de litige relatif à l'interprétation ou à l'exécution des présentes 
                  CGV, et à défaut de résolution amiable, les tribunaux compétents seront ceux 
                  du ressort du siège social du Vendeur, sauf disposition légale contraire 
                  applicable aux consommateurs.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-[#2D2D2D] mb-4" style={{ fontFamily: "'DM Serif Display', serif" }}>
                  ARTICLE 14 - CONTACT
                </h2>
                <p className="text-[#3A3A3A] leading-relaxed">
                  Pour toute question relative aux présentes CGV :<br /><br />
                  <strong>PROBWA</strong><br />
                  7 RUE ELIE EUDOR BUREAU N3<br />
                  97460 SAINT-PAUL<br />
                  La Réunion<br /><br />
                  Email : probwalareunion@gmail.com<br />
                  Téléphone : +262 692 50 26 85<br />
                  R.C.S. : 982 037 558 R.C.S. Saint Denis de La Réunion
                </p>
              </div>

              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm text-[#9E9E9E]">
                  Dernière mise à jour : Février 2026
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </motion.div>
  );
}
